import React from 'react';
import Currency from './Currency';

const SummaryRow = props => {
  const { label, children, rowClassName = '', labelClassName = '', digits = 2 } = props;
  
  return (
    <div className={`summary-row row ${rowClassName}`}>
      <span className={labelClassName}>{label}</span>
      <Currency digits={digits}>{children}</Currency>
    </div>
  );
};

export default SummaryRow;